import { initialState } from '@/store/initialState';

export const state = { ...initialState.profile};


// WEBPACK FOOTER //
// ./src/store/modules/profile/state.js